import mqttClient from './mqtt.client'

const defaultSubscribeOptions = {
  once: false,
}
class ResourceSubscriber {
  constructor() {
    this.callbacks = {}
    this.subscribedTopics = []
  }

  _getCallbacks(key) {
    if (!key || !this.callbacks[key]) {
      return []
    }
    return this.callbacks[key]
  }

  _addCallback(key, callback) {
    if (!key) {
      throw new Error(`Can not add callback for following key: ${key}`)
    }
    if (!this.callbacks[key]) {
      this.callbacks[key] = []
    }

    this.callbacks[key].push(callback)
  }

  _setCallback(key, callback) {
    if (!key) {
      throw new Error(`Can not set callback for following key: ${key}`)
    }
    this.callbacks[key] = [callback]
  }

  _removeCallbacks(key, callback) {
    const callbacks = this._getCallbacks(key)
    if (callback) {
      const idx = callbacks.indexOf(callback)
      if (idx > -1) {
        callbacks.splice(idx, 1)
      }
    } else {
      delete this.callbacks[key]
    }
  }

  init() {
    mqttClient.on('message', (topic, message) => {
      const callbacks = this._getCallbacks(topic)
      callbacks.forEach((callback) => {
        callback(message.toString())
      })
    })
  }

  subscribeResourceUri(uri, callback, options = defaultSubscribeOptions) {
    if (options.once) {
      this._setCallback(uri, callback)
    } else {
      this._addCallback(uri, callback)
    }
    mqttClient.subscribe(uri)
    this.subscribedTopics.push(uri)
  }

  unsubscribeResourceUri(uri, callback) {
    this._removeCallbacks(uri, callback)
    mqttClient.unsubscribe(uri)
    this.subscribedTopics = this.subscribedTopics.filter((topic) => topic !== uri)
  }
}

const resourcesSubscriber = new ResourceSubscriber()

export {
  resourcesSubscriber,
}
